module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-3-ab91e56381ce85bd7489c9fa4d1ddd74.svg";